module.exports = __webpack_public_path__ + "static/media/teams-footer-logo.a6961e5d.svg";